import { render, staticRenderFns } from "./TfView.vue?vue&type=template&id=6e00cfb7&scoped=true"
import script from "./TfView.vue?vue&type=script&lang=js"
export * from "./TfView.vue?vue&type=script&lang=js"
import style0 from "./TfView.vue?vue&type=style&index=0&id=6e00cfb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e00cfb7",
  null
  
)

export default component.exports